import { Select } from "antd";
import { useMemo } from "react";
import { useSportConfiguration } from "~hooks/useSportConfiguration";
import { useUpdateListFixture } from "../../hooks";
import type { ColumnComponentProperties } from "../../types";

export const StatusColumn = (properties: ColumnComponentProperties) => {
  const { mutate: updateFixture, isPending: isLoading } = useUpdateListFixture();
  const sportConfiguration = useSportConfiguration();

  const options = useMemo(() => sportConfiguration.fixtureStatuses.map((x) => ({ value: x, label: x })), [sportConfiguration]);

  if (properties.editMode) {
    const onChangeHandler = (value: string) =>
      updateFixture({
        fixtureId: properties.fixtureId,
        upsertData: {
          status: value,
        },
      });

    return (
      <Select disabled={isLoading} onChange={onChangeHandler} style={{ width: "100%" }} defaultValue={properties.value} options={options} />
    );
  }

  return properties.value;
};
